module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text",
    attrs: {
      "href": "#/TransferPending"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('TransferCompleted.sidebar.pending')) + "\n          ")]), _vm._v(" "), (_vm.pending.length > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.pending.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "current"
    }
  }, [_c('a', {
    staticClass: "nav-link navbar-text",
    attrs: {
      "href": "#/TransferCurrent"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('TransferCompleted.sidebar.completed')) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "card mb-3 bg-darkgrey"
  }, [_c('div', {
    staticClass: "color-grey",
    attrs: {
      "id": "stats"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.stats.processing')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.processing))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.stats.dispatch')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.dispatch))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.stats.pick')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.pick))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.stats.transit')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.transit))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.stats.delivered')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.drop))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.canceled')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.count.reject))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.title')))])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 40
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('transpName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.carrier'))), (_vm.sort.current === 'transpName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('orderRef', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.reference'))), (_vm.sort.current === 'orderRef') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('.key', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.order'))), (_vm.sort.current === '.key') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('vin', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.VIN'))), (_vm.sort.current === 'vin') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('creationDate', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.date'))), (_vm.sort.current === 'creationDate') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('transmitterName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.pickup'))), (_vm.sort.current === 'transmitterName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('receiverName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.delivery'))), (_vm.sort.current === 'receiverName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('status', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferCompleted.status'))), (_vm.sort.current === 'status') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filters"
  }, [_c('th'), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.transpName,
      "placeholder": _vm.$t('TransferCompleted.carrier')
    },
    on: {
      "input": function($event) {
        _vm.fields.transpName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.orderRef,
      "placeholder": _vm.$t('TransferCompleted.reference')
    },
    on: {
      "input": function($event) {
        _vm.fields.orderRef = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields['.key'],
      "placeholder": _vm.$t('TransferCompleted.order')
    },
    on: {
      "input": function($event) {
        _vm.fields['.key'] = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.vin,
      "placeholder": _vm.$t('TransferCompleted.VIN')
    },
    on: {
      "input": function($event) {
        _vm.fields.vin = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.creationDate,
      "placeholder": _vm.$t('TransferCompleted.date')
    },
    on: {
      "input": function($event) {
        _vm.fields.creationDate = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.transmitterName,
      "placeholder": _vm.$t('TransferCompleted.pickup')
    },
    on: {
      "input": function($event) {
        _vm.fields.transmitterName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.receiverName,
      "placeholder": _vm.$t('TransferCompleted.delivery')
    },
    on: {
      "input": function($event) {
        _vm.fields.receiverName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.status,
      "placeholder": _vm.$t('TransferCompleted.status')
    },
    on: {
      "input": function($event) {
        _vm.fields.status = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(transfer) {
    return _c('tr', {
      key: transfer['.key'],
      class: {
        'drop': transfer.status === 'Drop', 'cancel': transfer.status === 'Cancel', 'waiting': transfer.status === 'Waiting', 'pick': transfer.status === 'Pick', 'transit': transfer.status === 'Transit', 'dispatch': transfer.status === 'Dispatch', 'reject': transfer.status === 'Reject',
      }
    }, [_c('td', [_c('a', {
      attrs: {
        "href": '#/OrderInfo?orderId=' + transfer['.key']
      }
    }, [_c('input', {
      staticClass: "btn btn-kne-orange pull-right ",
      attrs: {
        "type": "button",
        "value": _vm.$t('TransferCompleted.view')
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(transfer.transpName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transfer.orderRef))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transfer['.key']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transfer.vin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(transfer.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(transfer.transmitterName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(transfer.receiverName))])]), _vm._v(" "), _c('td', [(transfer.status === 'Dispatch') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Processing') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.processing')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Pick') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Waiting') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Transit') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Drop') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Cancel') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Terminée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Transférée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]) : _vm._e(), _vm._v(" "), (transfer.status === 'Reject') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]) : _vm._e()])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d21d8f5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/TransferCompleted.vue
// module id = 831
// module chunks = 1